import AfterLoginGuard from "../../guards/AfterLoginGuard";
import ProtectedRoute from "../../guards/ProtectedRoute";
import ClinicalTrialList from "./ClinicalTrialList";
import ClinicalTrialForm from "./ClinicalTrialCreate";
import ClinicalTrialView from "./ClinicalTrialView";
import PublishedClinicalTrialList from "./PublishedClinicalTrialList";

const clinicalTrialRoutes = [
  {
    path: "/clinical-trial",
    element: <AfterLoginGuard />,
    children: [
      {
        path: "",
        element: (
          <ProtectedRoute
            element={<ClinicalTrialList />}
            permissions={["/auth/api/v1/auth/login"]}
          />
        ),
        title: "Clinical Trials",
      },
      {
        path: "list",
        element: (
          <ProtectedRoute
            element={<ClinicalTrialList />}
            permissions={["/auth/api/v1/auth/login"]}
          />
        ),
        title: "Clinical Trials",
      },
      {
        path: "list-published",
        element: (
          <ProtectedRoute
            element={<PublishedClinicalTrialList />}
            permissions={["/auth/api/v1/auth/login"]}
          />
        ),
        title: "Clinical Trials",
      },
      {
        path: "create",
        element: (
          <ProtectedRoute
            element={<ClinicalTrialForm />}
            permissions={["/auth/api/v1/auth/login"]}
          />
        ),
        title: "Clinical Trial — Create",
      },
      {
        path: "edit/:id",
        element: (
          <ProtectedRoute
            element={<ClinicalTrialForm />}
            permissions={["/auth/api/v1/auth/login"]}
          />
        ),
        title: "Clinical Trial — Edit",
      },
      {
        path: "view/:id",
        element: (
          <ProtectedRoute
            element={<ClinicalTrialView />}
            permissions={["/auth/api/v1/auth/login"]}
          />
        ),
        title: "Clinical Trial — View",
      },
    ],
  },
];

export default clinicalTrialRoutes;

export const clinicalTrialMenuItems = [
  {
    name: "Clinical Trials",
    route: "/clinical-trial/list",
    icon: "widgets",
    iconType: "MAT",
    permissions: ["/auth/api/v1/auth/login"],
  },
  {
    name: "Published Clinical Trials",
    route: "/clinical-trial/list-published",
    icon: "widgets",
    iconType: "MAT",
    permissions: ["/auth/api/v1/auth/login"],
  },
];
